import { Layout } from 'ui';
import Footer from 'ui/layouts/Footer';
import Header from 'ui/layouts/Header';
import MainNavigation from 'ui/layouts/MainNavigation';
import MobileNavigation from 'ui/layouts/MobileNavigation';
import MobileNavigationMenu from 'ui/layouts/MobileNavigation/MobileNavigationPrimary';

const type = process.env.NEXT_PUBLIC_LANDING_TYPE || '';

const domainExtensions = {
  "esfj": "com",
}

const LogoText = ({ name = '' }) => (
  <>
    <span className="font-bold">{name.toUpperCase()}</span>.{domainExtensions[type] || 'net'}
  </>
);

const menuItems = [
  {
    href: '/blog',
    label: 'Blog',
  },
  {
    href: '/posts',
    label: 'Posts',
  },
]
const footerItems = [
  [{title: 'Contact', href: '/contact'}, {title: 'Test', href: '/free-personality-test'}],
  [{title: 'About us', href: '/about-us'}],
  [{title: 'Terms & Conditions', href: '/terms-conditions'}, {title: 'Privacy policy', href: '/privacy'}],
]
function LandingLayout({ children, headerProps }) {
  return (
    <Layout
      header={
        <Header
          logoText={<LogoText name={type} />}
          hasSearchSuggestions={false}
          mainNavigation={
            <MainNavigation
              items={menuItems}
            />
          }
          mobileNavigation={
            <MobileNavigation>
              <MobileNavigationMenu
                items={menuItems}
                hasAuthAction={false}
              />
            </MobileNavigation>
          }
          hasLoginAction={false}
          {...headerProps}
        />
      }
      footer={<Footer items={footerItems} />}
    >
      {children}
    </Layout>
  );
}

export default LandingLayout;
